import type { Spread } from "../bdl/model";
import { Figure } from "./Figure";

/**
 * A chain, read top to bottom: every beat with its figure moving, the label,
 * and the body — the app's sideways swipe laid out as a page (philosophy/01).
 */
export function Chain({ spread, animate = true }: { spread: Spread; animate?: boolean }) {
  const beats = spread.chain.beats;
  return (
    <div className="chain">
      <div className="title">{spread.card.title}</div>
      {beats.map((b, i) => {
        const fig = spread.figures[b.figureId];
        return (
          <div key={i} className={`beat beat-${b.role}`}>
            {fig && <Figure className="figure" figure={fig} size={300} animate={animate} />}
            {/* What the card shows: the figure, the line, the body. The head is a label, not shown. */}
            <div className="head">{b.line ?? b.head}</div>
            <p className={b.role === "say" ? "trick" : undefined}>{b.body}</p>
          </div>
        );
      })}
    </div>
  );
}
